export const theme = {
    primary: "#FF761C",
    secondary: "#232655",
    accent: "#9c27b0",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
}


// WEBPACK FOOTER //
// ./src/theme.js